import React, { useEffect, useState } from "react"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"

import { ProgramProps } from "../interfaces"
import { mediaMax } from "../../../utils/breakpoints"
import HorizontalScroll from "../../../utils/horizontalScroll/horizontal-scroll"
import { DateButton, Timeline, DetailItem } from './index';

const Program = ({
  isActive = "notActive",
  liveSpeaker,
  speakerLinks,
  backgroundImage,
  data,
  title,
  liveUrl,
  hideTimeline,
  smallerLogo,
}: ProgramProps) => {

  const [activedate, setActiveDate] = useState(0)
  const [speakersByDate, setSpeakersByDate] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);

  const liveSpeakerSlug = liveSpeaker ? liveSpeaker.slug : null
  const withLinkList = speakerLinks != null ? speakerLinks : []

  const [showMobile, setShowMobile] = useState(false)
  useEffect(() => {
    const resp = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    setShowMobile(resp)
  }, [])

  useEffect(() => {
    const getData = () => {
      //Get a list of unique dates from the whole list of speakers
      const uniqueDates = Array.from(new Set(data.map(a => a.node.date)))
        .map(date => {
          return data.find(a => a.node.date === date)
        })
        .sort((x, y) => {
          if (x.node.date >= y.node.date) {
            return 1
          } else {
            return -1
          }
        })

      //create an object with a list of speakers for each unique day
      for (let i = 0; i < uniqueDates.length; i++) {
        const listOjbect = {
          date: uniqueDates[i].node.date,
          array: data.filter(
            item => item.node.date === uniqueDates[i].node.date
          ),
        }
        speakersByDate.push(listOjbect)
      }

      setDataLoading(false);
    }

    getData()
  }, [])

  const handleDayClick = (index: number) => {
    setActiveDate(index)
  }

  return (
    <StyledContainer
      fluid={backgroundImage.childImageSharp.fluid}
      className={isActive}
      id="myScroller"
    >
      <StyledTop>
        <h1>{title}</h1>
        <StyledDayChoices>
          {speakersByDate.map((day, index) => {
            const parsedDay = new Date(day.date).getDate()
            const startOfDay = day.array[0].node.time

            const endOfDay = day.array[day.array.length - 1].node.timeEnd
            return (
              <DateButton handleDayClick={() => handleDayClick(index)} isActive={index === activedate} day={parsedDay} start={startOfDay} end={endOfDay} key={parsedDay}></DateButton>
            )
          })}
        </StyledDayChoices>
      </StyledTop>

      {!dataLoading && 
        <>
          {!hideTimeline && (
            <Timeline speakerArray={speakersByDate[activedate].array} liveUrl={liveUrl} activeDate={activedate}></Timeline>
          )}

          {!showMobile && (
            <HorizontalSection>
              <HorizontalScroll
                smallerImage={smallerLogo}
                activedate={activedate}
                dataArray={speakersByDate[activedate].array}
                liveSpeakerSlog={liveSpeakerSlug}
                withLinkList={withLinkList}
              ></HorizontalScroll>
            </HorizontalSection>
          )}
          {showMobile && (
            <MobileEventWrapper>
              {speakersByDate[activedate].array.map((speaker, index) => {
                return (
                  <DetailItem
                    key={speaker.node.slug}
                    linkList={withLinkList}
                    liveSpeakerSlug={liveSpeakerSlug}
                    index={index}
                    speakerKey={speaker.node.slug}
                    Url={"/speaker/" + speaker.node.slug}
                    time={speaker.node.time}
                    title={speaker.node.title}
                    speakerName={speaker.node.speakerName}
                    companyName={speaker.node.companyName}
                    image={speaker.node.image}
                  ></DetailItem>
                )
              })}
            </MobileEventWrapper>
          )}
        </>
      }

      
    </StyledContainer>
  )
}

const MobileEventWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow: auto;
  width: 100vw;
`

const HorizontalSection = styled.section`
  position: relative;
  width: 100%;
  height: 250px;
  overflow: hidden;
`

const StyledTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 81vw;
  margin-left: 9.5vw;
  margin-bottom: 70px;

  h1 {
    color: #ffffff;
    font-family: "Adelle";
    font-size: 48px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 72px;
    margin-bottom: 0px;
  }

  @media ${mediaMax.tabletL} {
    display: flex;
    flex-direction: column;
  }

  @media ${mediaMax.mobileL} {
    margin-bottom: 35px;
  }
`

const StyledDayChoices = styled.div`
  display: flex;
  flex-direction: row;
`

const StyledContainer = styled(BackgroundImage)`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  transition: transform 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;

  &:before {
    filter: blur(2px);
  }
`

export default Program;